module.exports = __webpack_public_path__ + "media/images/bnr_side_1-eb763ce685da4253c4679d33109b8c12.jpg";